import React, { useState, useRef, useEffect } from "react";
import { FaBars } from "react-icons/fa";
import { LogOut, User, Settings, UserCircle } from "lucide-react";
import { Link } from "react-router-dom";
import "./Header.css";
import { useAuth } from "../Context/authContext";
import CompanyDropdown from "./CompanyDropdown";

const Header = ({ isSidebarOpen, toggleSidebar }) => {
  const { user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
  const settingsDropdownRef = useRef(null);

  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (
        settingsDropdownRef.current &&
        !settingsDropdownRef.current.contains(event.target)
      ) {
        setShowSettingsDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const toggleSettingsDropdown = (event) => {
    event.stopPropagation(); // Prevent parent dropdown from closing
    setShowSettingsDropdown(!showSettingsDropdown);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  let handleLogout = () => {
    localStorage.removeItem("token");
  };

  return (
    <header className="header py-2 px-3 bg-white shadow-sm">
      <div className="header-left">
        <FaBars className="menu-icon" onClick={toggleSidebar} />
        <div className="main-heading">
          <img
            src="https://produc8ive.com/images/logo%20hero.png"
            width={150}
            alt="header_image"
            className="img-fluid"
          ></img>
        </div>
      </div>

      <div className="header-right">
       

        <div className="header-auth-section">
          {user ? (
            <div className="profile-dropdown" ref={dropdownRef}>
              <div className="profile-trigger" onClick={toggleDropdown}>
                <div className="user-avatar">
                  {user.avatar ? (
                    <img
                      src={user.avatar}
                      alt="User"
                      className="avatar-image"
                    />
                  ) : (
                    <UserCircle size={40} className="default-avatar" />
                  )}
                </div>
              </div>

              {showDropdown && (
                <div className="dropdown-menu show">
                  <div className="dropdown-header">
                    <div className="d-flex align-items-center">
                      <UserCircle size={48} className="me-2" />
                      <div>
                        <h6 className="mb-0">{user.email}</h6>
                        <small className="text-muted">Free Account</small>
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-divider"></div>

                  <Link to="/profile" className="dropdown-item">
                    <User size={18} className="me-2" />
                    My Profile
                  </Link>

                  <Link to="/settings" className="dropdown-item">
                    <Settings size={18} className="me-2" />
                    Settings
                  </Link>

                  <div className="dropdown-divider"></div>

                  <button
                    onClick={logout}
                    className="dropdown-item text-danger"
                  >
                    <LogOut size={18} className="me-2" />
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/login" className="login-button">
              Login
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
